import { render, staticRenderFns } from "./OrderManage.vue?vue&type=template&id=04e5c89e&scoped=true&"
import script from "./OrderManage.vue?vue&type=script&lang=ts&"
export * from "./OrderManage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04e5c89e",
  null
  
)

export default component.exports